import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../supabaseClient";
import { selectUser } from "../slices/userReducer";
import { useSelector } from "react-redux";
import Modal from "./Modal";

export default function SuggestionsModal({
  show,
  setShow,
  isFeedback = false,
}) {
  const { t } = useTranslation();

  const [suggestion, setSuggestion] = useState("");
  const [feedback, setFeedback] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [error, setError] = useState(false);

  const user = useSelector(selectUser);

  const handleSubmit = () => {
    if (isFeedback) {
      if (!feedback || !email || !phoneNumber) {
        setError(true);
        return;
      }

      supabase
        .from("Suggestion")
        .insert({
          event: feedback,
          email,
          phone_number: phoneNumber,
          is_feedback: true,
        })
        .then((res) => {
          if (res.error) {
            console.log(res.error);
          } else {
            setShow(false);
            setFeedback("");
          }
        });
    } else {
      if (!suggestion || !email || !phoneNumber) {
        setError(true);
        return;
      }

      supabase
        .from("Suggestion")
        .insert({
          event: suggestion,
          email,
          phone_number: phoneNumber,
          is_feedback: false,
        })
        .then((res) => {
          if (res.error) {
            console.log(res.error);
          } else {
            setShow(false);
            setSuggestion("");
          }
        });
    }
  };

  useEffect(() => {
    if (user.email && user.phone_number) {
      setEmail(user.email);
      setPhoneNumber(user.phone_number);
    }
  }, [user, show]);

  return (
    <Modal
      show={show}
      onClose={() => setShow(false)}
      title={isFeedback ? t("leave_feedback") : t("leave_a_suggestion")}
      preventClose={true}
    >
      <p className="text-[16px] text-white leading-[22px]">
        {isFeedback ? t("feedback_description") : t("suggestions_description")}
      </p>

      {isFeedback ? (
        <textarea
          className="bg-transparent focus:bg-[#1D1726] p-[16px] !pb-[16px] border border-neutral-400 focus:border-neutral-400 rounded-[4px] outline-nonefocus:!outline-none focus:ring-0 w-full text-[14px] text-white placeholder-neutral-400"
          rows="5"
          onChange={(e) => {
            setFeedback(e.target.value);
          }}
          placeholder={t("feedback_placeholder")}
          value={feedback}
        />
      ) : (
        <input
          className="bg-transparent focus:bg-[#1D1726] p-[16px] !pb-[16px] border border-neutral-600 focus:border-neutral-400 rounded-[4px] outline-nonefocus:!outline-none focus:ring-0 w-full text-[14px] text-white placeholder-neutral-400"
          type="text"
          onChange={(e) => {
            setSuggestion(e.target.value);
          }}
          placeholder={t("event_name")}
          value={suggestion}
        />
      )}

      {!user.id && (
        <>
          <input
            className="bg-transparent focus:bg-[#1D1726] p-[16px] !pb-[16px] border border-neutral-600 focus:border-neutral-400 rounded-[4px] outline-nonefocus:!outline-none focus:ring-0 w-full text-[14px] text-white placeholder-neutral-400"
            placeholder={t("email")}
            type="email"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            value={email}
          />
          <input
            className="bg-transparent focus:bg-[#1D1726] p-[16px] !pb-[16px] border border-neutral-600 focus:border-neutral-400 rounded-[4px] outline-nonefocus:!outline-none focus:ring-0 w-full text-[14px] text-white placeholder-neutral-400"
            placeholder={t("phone_number")}
            type="text"
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
            value={phoneNumber}
          />
        </>
      )}

      {error && (
        <p className="mt-[12px] font-semibold text-[16px] text-red-500">
          Vul alle velden in.
        </p>
      )}

      <button
        onClick={handleSubmit}
        className="disabled:bg-[#56466B] !p-[12px] !rounded-[6px] !w-full !text-[16px] !text-white premium-button"
      >
        {t("send")}
      </button>
    </Modal>
  );
}
